import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
  container: {
    background: '#FAFAFA',
    borderRadius: 5,
    width: '100%',
    height: '100%',
    minHeight: '692px',
    maxWidth: 1100,
  },
  blockContent: {
    padding: 20,
    position: 'relative',
    zIndex: 2,
  },
  title: {
    color: '#272727',
    fontFamily: 'Open Sans',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 700,
    textTransform: 'uppercase',
  },
  titleType: {
    color: '#272727',
    fontFamily: 'Open Sans',
    fontSize: 12,
    fontStyle: 'normal',
    textTransform: 'none',
    marginRight: 15,
  },
  blockType: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  blockTypeInside: {
    display: 'flex',
    alignItems: 'center',
  },
  blockText: {
    width: '100%',
    minHeight: '160px',
    marginTop: 12,
  },
  blockText2: {
    width: '100%',
    minHeight: '338px',
    marginTop: 12,
  },
  select: {
    fontFamily: 'Poppins',
    fontSize: 12,
    fontWeight: 500,
  },
  containerChoice: {
    width: '100%',
    height: 'calc(100% - 15px)',
    minHeight: '230px',
  },
  blockContentParent: {
    display: 'flex',
    flexDirection: 'column',
  },
  choice: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderRadius: 5,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#f1f1f1',
    width: '100%',
    height: '100%',
  },
  iconBtnImage: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    top: '-3%',
    right: '-3%',
  },
  icon: {
    width: '14px',
    height: '14px',
  },

  titleEndGame: {
    fontFamily: 'Open Sans',
    fontSize: '12px',
    lineHeight: '12px',
    color: '#272727',
    fontWeight: 600,
    textAlign: 'center',
    marginBottom: '5px',
  },
  blockPadding: {
    padding: '25px 130px',
  },
  containerMedia: {
    display: 'flex',
    width: '100%',
    border: '1px solid #ddd',
  },
  child: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  separator: {
    borderRight: '1px solid #ccc',
  },

  modal: {
    '& .MuiPaper-root': {
      borderRadius: 16,
    },
  },
  formInput: {
    width: 400,
    '& div fieldset': {
      borderColor: '#0E1247',
    },
    // '& div input': {
    //   paddingTop: 10,
    //   paddingBottom: 10,
    // },
  },
  container2: {
    background: '#FAFAFA',
    borderRadius: 5,
    width: '100%',
    height: '100%',
    minHeight: '692px',
  },
  containerPaper: {
    '& .MuiDialog-paper': {
      padding: '10px',
      maxWidth: 'none',
      borderRadius: 20,
      width: '880px',
      '@media only screen and (max-width: 600px)': {
        padding: '0px !important',
      },
    },
  },
  btn: {
    display: 'block',
    margin: 'auto',
    marginBottom: 10,
    background: '#000A8C',
    marginTop: 20,
  },
  flexContent: {
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
  },
  btnClose: {
    background: '#E63C3C',
    position: 'absolute',
    top: 0,
    right: 0,
  },
  traitVertical: {
    position: 'absolute',
    left: '50.5%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: 2,
    height: 200,
    background: '#D4D4D8',
  },
  mediaEmptyContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    border: '1px solid #ddd',
    paddingTop: 24,
    paddingBottom: 24,
    cursor: 'pointer',
    outline: 'none',
    flex: 1,
    backgroundColor: '#f1f1f1',
  },
  mediaEmptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 20,
    width: '100%',
    maxWidth: 480,
  },
  mediaEmptyIconWrap: {
    width: 64,
    height: 64,
    borderRadius: 16,
    backgroundColor: '#eae9ea',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  mediaEmptyUploadIcon: {
    width: 32,
    height: 32,
    flexShrink: 0,
    '& path': {
      fill: '#000A8C',
    },
  },
  mediaEmptyTextBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
    width: '100%',
    textAlign: 'center',
  },
  mediaEmptyTitle: {
    fontFamily: 'Open Sans',
    fontSize: 16,
    fontWeight: 600,
    color: '#000000',
    lineHeight: 'normal',
  },
  mediaEmptySubtitle: {
    fontFamily: 'Open Sans',
    fontSize: 16,
    fontWeight: 400,
    color: '#383838',
    lineHeight: 'normal',
  },
  mediaEmptyActions: {
    display: 'flex',
    gap: 8,
    width: '100%',
  },
  mediaImportBtn: {
    flex: 1,
    height: 40,
    minHeight: 40,
    borderRadius: 4,
    backgroundColor: '#000A8C',
    color: '#FFFFFF',
    textTransform: 'none',
    fontFamily: 'Open Sans',
    fontSize: 14,
    fontWeight: 600,
    letterSpacing: '0.28px',
    padding: '8px 24px',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#000070',
    },
  },
  mediaImportBtnIcon: {
    width: 16,
    height: 16,
    flexShrink: 0,
    display: 'block',
    '& path': {
      fill: '#FFFFFF',
    },
  },
  nativeVideo: {
    width: '100%',
    maxHeight: 514,
    display: 'block',
  },
}));
